// Formatting helpers for The Padel Draw. British English throughout.

export const formatGBP = (amount) => {
  const value = Number(amount || 0);
  const formatted = value.toLocaleString('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: value % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  });
  return formatted;
};

export const formatGBPfromPence = (pence) => formatGBP((pence || 0) / 100);

export const formatNumber = (n) => Number(n || 0).toLocaleString('en-GB');

export const formatDateShort = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const formatDateLong = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleString('en-GB', {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const timeLeft = (iso) => {
  if (!iso) return { days: 0, hours: 0, minutes: 0, seconds: 0, total: 0, urgent: false };
  const now = Date.now();
  const target = new Date(iso).getTime();
  const total = Math.max(0, target - now);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((total / (1000 * 60)) % 60);
  const seconds = Math.floor((total / 1000) % 60);
  return { days, hours, minutes, seconds, total, urgent: total > 0 && total < 24 * 60 * 60 * 1000 };
};

export const clampPct = (n) => Math.max(0, Math.min(100, Math.round(n)));

// Odd/even ticket pricing — mirrors backend calculate_order_total_pence.
// Odd-position tickets (1st, 3rd, 5th...) at the base price; even-position
// tickets (2nd, 4th, 6th...) at the fixed £1.00 rate. Frontend uses this
// for display only; the server number in POST /api/payments/checkout is
// what actually gets charged.
export const EVEN_TICKET_PRICE_PENCE = 100;

export const calculateOrderTotalPence = (basePriceGbp, quantity) => {
  if (!quantity || quantity <= 0) return 0;
  const basePence = Math.round((basePriceGbp || 0) * 100);
  const oddCount = Math.ceil(quantity / 2);
  const evenCount = Math.floor(quantity / 2);
  return oddCount * basePence + evenCount * EVEN_TICKET_PRICE_PENCE;
};

// Convenience: label like "2 tickets · £3.99" for quick-pick buttons.
export const quickPickLabel = (basePriceGbp, quantity) => {
  const totalPence = calculateOrderTotalPence(basePriceGbp, quantity);
  return `${quantity} ${quantity === 1 ? 'ticket' : 'tickets'} \u00b7 ${formatGBPfromPence(totalPence)}`;
};
